import React from 'react';
import { withStyles } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';

export class GeneralFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
           }};


  render() {    
    return (
      <div>
  
      <div className="" style={{marginTop: "40px", fontFamily: "Montserrat", backgroundColor: "none"}}> 
        <div className="container" style={{maxWidth: "1024px"}}>
          <div className="row" style={{paddingTop: "20px"}}>
          <div className="col-12 col-md-6" style={{textAlign: "left"}}>
              
          <h4 style={{color: "white", textShadow: "1px 1px 3px rgba(0, 0, 0, 1)"}}>Yhteystiedot</h4>
          <span className="applyText" style={{color: "white", textShadow: "1px 1px 3px rgba(0, 0, 0, 1)"}}>
              Asiakaspalvelumme palvelee ark. 
              09:00-16:00 numerossa <b>09-6829 8003</b><br/>              
              Sähköpostitse palvelemme osoitteessa <b>asiakaspalvelu@kasvurahoitus.fi</b> <br/><br/>
              Front-ryhmä muodostuu rahoitukseen sijoituspalveluihin keskittyvästä Front Group-konsernista ja yritysrahoitukseen keskittyvästä Front Finance -konsernista.
            </span>      
          </div>
          
          <div className="col-12 col-md-6" style={{textAlign: "left"}}>
          <h4 style={{color: "white", textShadow: "1px 1px 3px rgba(0, 0, 0, 1)"}}>Front Kasvurahoitus</h4>           
          <span className="applyText" style={{color: "white", textShadow: "1px 1px 3px rgba(0, 0, 0, 1)"}}>Vertaislaina Oy, Y-tunnus 2321467-7, Joukahaisenkatu 1, 20520 Turku<br/>
          Front Kasvurahoitus on Front-ryhmän online-pohjainen yritysrahoituspalvelu. </span>

           </div>
          </div>
        </div>
      </div>
      </div>
 
    );
  }
}

